import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=73c2f0a8"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c2f0a8')) {
      api.createRecord('73c2f0a8', component.options)
    } else {
      api.reload('73c2f0a8', component.options)
    }
    module.hot.accept("./RegionList.vue?vue&type=template&id=73c2f0a8", function () {
      api.rerender('73c2f0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/RegionList.vue"
export default component.exports